/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Not_NeededInputs */

const en_error_invitation_not_needed = /** @type {(inputs: Error_Invitation_Not_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The brand already submitted its linesheet for the season of this campaign.`)
};

/**
* | output |
* | --- |
* | "The brand already submitted its linesheet for the season of this campaign." |
*
* @param {Error_Invitation_Not_NeededInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_not_needed = /** @type {((inputs?: Error_Invitation_Not_NeededInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Not_NeededInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_invitation_not_needed(inputs)
});